<template>
	<div>
		<el-page-header @back="goBack" content="人格类型结果设置"></el-page-header>
		<div class="topic-outer">
			<div class="appraisal-center fonts">
				<div class="pub-line">
					<span>分类：</span>
					<span class="glay"
						>{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
					>
				</div>
				<div class="flex-box pub-line">
					<div class="fl1">
						<span>名称：</span>
						<span class="glay">{{ detalisObj.name }}</span>
					</div>
					<div class="fl1">
						<span> 标识：</span>
						<span class="glay">{{ detalisObj.examId }}</span>
					</div>
				</div>

				<div class="flex-box pub-line">
					<div class="fl1">
						<span>解析：</span>
						<span class="glay">{{ detalisObj.schemeName }}</span>
					</div>
					<div class="fl1">
						<span> 题目：</span>
						<span class="glay"
							>共 <i>{{ detalisObj.questions }}</i
							>题</span
						>
					</div>
				</div>
			</div>
		</div>
		<div class="second_tops" v-loading="loading">
			<div style="min-height: 56vh">
				<template v-if="initJZData && initJZData.length">
					<el-tabs
						tab-position="left"
						v-model="activeName"
						@tab-click="handTabClick"
					>
						<el-tab-pane
							v-for="item in initJZData"
							:key="item.examResultId"
							:label="item.name"
							:name="item.examResultId.toString()"
						>
						</el-tab-pane>
						<div>
							<div class="public-dialog-form">
								<el-form
									ref="ruleForm"
									:model="params"
									label-width="110px"
									label-position="left"
								>
									<el-row>
										<el-tabs
											type="card"
											v-model="languageCode"
											@tab-click="handleTabClick('question')"
										>
											<el-tab-pane
												v-for="(item, index) in languageList"
												:label="item.name"
												:name="item.code"
												:key="index"
											></el-tab-pane>
										</el-tabs>
									</el-row>
									<el-row>
										<el-col :span="8">
											<el-form-item label="图片">
												<div class="diplay" style="margin-right: 10px">
													<div class="screenshot">
														<span
															v-for="(imgUrl, index) in srcList"
															:key="index"
															class="slideshow"
														>
															<el-image
																style="
																	width: 100px;
																	height: 100px;
																	border-radius: 6px;
																"
																:src="imgUrl"
																fit="cover"
																@click="getPolicy"
															/>
														</span>
														<div
															class="up-btn"
															style="
																width: 100px;
																height: 100px;
																line-height: 100px;
															"
															@click="getPolicy"
															v-if="isMoer"
														>
															<i class="el-icon-plus"></i>
														</div>
													</div>
													<input
														type="file"
														ref="file"
														@change="getFile"
														accept="image/png,image/jpg"
													/>
												</div>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="22">
											<el-form-item label="人格类型名称" prop="name">
												<el-input
													placeholder="请填写人格类型名称"
													v-model="params.name"
												></el-input>
											</el-form-item>
											<el-form-item label="心里标签与特征描述" prop="descr">
												<rich-text
													v-if="innerVisible"
													:keyWord="'descr'"
													:params="params ? params : ''"
												></rich-text>
											</el-form-item>
											<el-form-item
												label="关联的潜意识神秘现象和真实案例"
												prop="relationships"
											>
												<rich-text
													v-if="innerVisible"
													:keyWord="'relationships'"
													:params="params ? params : ''"
												></rich-text>
											</el-form-item>
											<el-form-item
												label="潜意识的影响和作用机制"
												prop="suggest2"
											>
												<rich-text
													v-if="innerVisible"
													:keyWord="'suggest2'"
													:params="params ? params : ''"
												></rich-text>
											</el-form-item>
											<el-form-item
												label="理论支持与学术解释"
												prop="guideSuggest"
											>
												<rich-text
													v-if="innerVisible"
													:keyWord="'guideSuggest'"
													:params="params ? params : ''"
												></rich-text>
											</el-form-item>
											<el-form-item label=" 个性化建议" prop="suggest">
												<rich-text
													v-if="innerVisible"
													:keyWord="'suggest'"
													:params="params ? params : ''"
												></rich-text>
											</el-form-item>
											<el-form-item label=" 梦境解析-内容" prop="content">
												<rich-text
													v-if="innerVisible"
													:keyWord="'content'"
													:params="params ? params : ''"
												></rich-text>
											</el-form-item>
											<el-form-item label=" 梦境启示-内容" prop="keyword">
												<rich-text
													v-if="innerVisible"
													:keyWord="'keyword'"
													:params="params ? params : ''"
												></rich-text>
											</el-form-item>
										</el-col>
									</el-row>
								</el-form>
								<span slot="footer" class="public-dialog-footer">
									<el-button size="medium" @click="handleContentEdit('reset')">
										重 置</el-button
									>
									<el-button
										size="medium"
										type="primary"
										@click="handleContentEdit('add')"
										>提 交</el-button
									>
								</span>
							</div>
						</div>
					</el-tabs>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import { emptyShow, isEmpty } from "@utils/tools";
import richText from "@comp/richText";
import { ossUpload } from "@utils/filters/upload";

export default {
	name: "mjywlList",
	components: {
		richText,
	},
	data() {
		return {
			emptyShow,
			isEmpty,
			detalisObj: {},
			loading: false,
			initJZData: [],
			activeName: "",
			params: {},
			innerVisible: false,
			srcList: [],
			isMoer: true,
		};
	},
	watch: {},
	mounted() {
		this.getAppraisalData();
		this.initJZ();
		this.getLanguageList();
	},
	methods: {
		//获取语言列表
		async getLanguageList() {
			this.loading = true;
			//角色列表
			const { data: res } = await this.$post(`/language/list`, {
				adminStatus: 1,
			});
			this.loading = false;
			this.languageList = res.data;
			this.languageCode = res.data[0].code;
		},
		handleTabClick(e) {
			if (e == "question") {
				this.resultDetails(this.activeName);
			}
		},
		handTabClick(data) {
			this.innerVisible = false;
			this.srcList = [];
			this.isMoer = true;
			this.params = {};
			this.params.examResultId = parseInt(data.name);
			this.resultDetails(data.name);
		},
		/**
		 * 初始化基准
		 */
		async initJZ() {
			this.loading = true;
			const { data: resData } = await this.$post(
				`exam/result/init/datum/${this.$route.query.examId}`,
				{
					headers: {
						"Language-Code": this.languageCode,
					},
				}
			);
			if (resData.result != 200) {
				this.loading = false;
				return;
			}
			if (resData.data) {
				this.loading = false;
				this.initJZData = resData.data;
				this.activeName = resData.data[0].examResultId.toString();
				this.params.examResultId = resData.data[0].examResultId;
				this.resultDetails(resData.data[0].examResultId);
			} else {
				this.initJZData = [];
				this.loading = false;
			}
		},
		async resultDetails(examResultId) {
			this.innerVisible = false;
			const { data: resData } = await this.$get(
				`exam/result/info/${examResultId}`,
				{
					headers: {
						isLoading: true,
						"Language-Code": this.languageCode,
					},
				}
			);
			if (resData.result != 200) return;
			this.srcList = [];
			this.isMoer = true;
			if (resData.data) {
				if (resData.data.icon) {
					this.srcList.push(resData.data.icon);
					this.isMoer = false;
				}
				this.params = resData.data;
				this.innerVisible = true;
			} else {
				this.params = {};
				this.innerVisible = true;
			}
		},
		handleContentEdit(type) {
			if (type == "add") {
				this.$refs.ruleForm.validate((valid) => {
					if (!valid) return;
					this.$confirm("确认保存数据, 是否继续?", "提示", {
						type: "info",
					}).then(async () => {
						const { data: resData } = await this.$put(
							"exam/result/info",
							this.params,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						this.$message.success("提交成功!");
					});
				});
			} else if (type == "reset") {
				this.$confirm("确认重置当前数据, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					const { data: resData } = await this.$post(
						"exam/result/init/datum/" + this.$route.query.examId,
						{
							headers: {
								isLoading: true,
								"Language-Code": this.languageCode,
							},
						}
					);
					this.$message.success("重置成功!");
				});
			}
		},
		/**
		 * 获取测评详情
		 */
		async getAppraisalData() {
			this.loading = true;
			const { data: resData } = await this.$get(
				`exam/info/${this.$route.query.examId}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.detalisObj = resData.data;
		},
		/**
		 * 返回
		 */
		goBack() {
			this.$router.back();
		},
		getPolicy() {
			this.$refs.file.dispatchEvent(new MouseEvent("click"));
		},
		async getFile() {
			const that = this;
			const { data: resData } = await this.$get("/aliyun/oss/sign", {
				headers: {
					isLoading: true,
					"Language-Code": this.languageCode,
				},
			});
			if (resData.result != 200) return;
			const addRoutes = await ossUpload(
				that.$refs.file.files[0],
				resData.data,
				"one", //'more','one'
				this.srcList
			);
			this.isMoer = false;
			this.srcList = addRoutes;
			this.params.icon = this.srcList[0];
		},
	},
};
</script>

<style scoped lang="scss">
.appraisal-center {
	width: 90%;
	margin: 0 auto;
}

.fonts {
	font-size: 14px;
}

.topic-outer {
	width: 100%;
	background: #fff;
	overflow: hidden;
	margin-top: 20px;
	padding-bottom: 30px;
}

.flex-box {
	display: -webkit-box;
	display: -moz-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
}

.fl1 {
	flex: 1;
	-webkit-flex: 1;
}

.glay {
	color: #8492a6;

	i {
		font-style: normal;
		color: #f56c6c;
	}
}

.pub-line {
	margin-top: 30px;
}

.marr {
	margin-top: 20px;
}

.tag-marr {
	margin-right: 5px;
	cursor: pointer;
}
.second_tops {
	padding-top: 20px;
	box-sizing: border-box;
}
.public-dialog-form {
	height: 55vh;
	overflow-y: scroll;
}
</style>
<style>
.second_tops .el-tabs__item {
	white-space: pre-wrap;
	text-align: left !important;
	line-height: 46px;
	max-width: 300px;
	height: 46px !important;
}
</style>
